import React, { useEffect } from 'react'
import useForm from 'react-hook-form'
import { routes } from 'routes'
import { reverse } from 'named-urls'
import { useHistory, Link } from 'react-router-dom'
import useSnackbar from 'hooks/useSnackbar'

import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import Select from '@material-ui/core/Select'
import { TextField, Button, FormControl } from '@material-ui/core'
import InputLabel from '@material-ui/core/InputLabel'
import { makeStyles } from '@material-ui/styles'

import { InputCurrency } from 'components/Form'

import styles from './styles'
import schema from '../../schemas'

import * as service from 'service'

const useStyles = makeStyles(styles)

const dataSchema = schema.data

const EntriesForm = ({ match }) => {
  let contractId = match.params.contractId
  const history = useHistory()
  const snackbar = useSnackbar()

  const { handleSubmit, register, watch, setValue, errors } = useForm({
    validationSchema: dataSchema,
  })
  const classes = useStyles()

  useEffect(() => {
    register({ name: 'price' })
  }, [register])

  const inputLabel = React.useRef(null)
  const [labelWidth, setLabelWidth] = React.useState(0)

  React.useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth)
  }, [])

  const [open] = React.useState(false)

  const onSubmit = async entry => {
    try {
      if (entry.type === '1') {
        entry.price = entry.price * -1
      }
      await service.recurrence.entries.create({ contractId, entry })

      snackbar.open({
        message: 'Cobrança adicional criada com sucesso!',
        variant: 'success',
      })

      history.push(reverse(routes.contracts.show, { contractId }))
    } catch (error) {
      snackbar.open({
        message: 'Erro ao criar cobrança adicional!',
        variant: 'error',
      })
    }
  }

  const values = watch()

  return (
    <Paper>
      <Box p={1} mt={2}>
        <form onSubmit={handleSubmit(onSubmit)} id="entry-create-form">
          <FormControl
            variant="outlined"
            className={classes.selectWidth}
            margin="dense"
          >
            <InputLabel ref={inputLabel} htmlFor="select-input">
              Tipo
            </InputLabel>
            <Select
              open={open}
              native
              inputRef={register}
              id="select-input"
              labelWidth={labelWidth}
              name="type"
            >
              <option value={0}>Acréscimo</option>
              <option value={1}>Desconto</option>
            </Select>
          </FormControl>
          <InputCurrency
            label="Valor"
            name="price"
            onChange={event => setValue('price', event.target.value)}
            margin="dense"
            className={classes.currencyWidth}
            value={values.price}
            error={errors.price !== undefined}
            helperText={errors.price ? errors.price.message : ''}
          />
          <TextField
            label="Descrição"
            margin="dense"
            name="description"
            inputRef={register}
            error={errors.description !== undefined}
            helperText={errors.description ? errors.description.message : ''}
            fullWidth
          />
        </form>
      </Box>
      <Box p={2}>
        <Button
          color="primary"
          variant="contained"
          className={classes.button}
          type="submit"
          form="entry-create-form"
        >
          Incluir
        </Button>

        <Button
          component={Link}
          color="primary"
          variant="outlined"
          to={reverse(routes.contracts.show, { contractId })}
        >
          Cancelar
        </Button>
      </Box>
    </Paper>
  )
}

export default EntriesForm
